import { render } from "./GlobalComs.vue?vue&type=template&id=40a50c6d&ts=true"
import script from "./GlobalComs.vue?vue&type=script&lang=ts"
export * from "./GlobalComs.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/yong/woolive/webtpl/web/events/uinfo/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__